import { useCallback } from 'react';
import { message } from 'antd';
import { axiosApi } from '../../../axios-api';
import { appBackendApi } from '../../../app/appBackendApi';


export function useGraphicEditorMedia({ project, getImages }) {
  const uploadImage = useCallback(
    async (file) => {
      try {
        if (!project) return;
        const formData = new FormData();
        formData.append('image', file, file.name);
        formData.append('name', file.name);
        formData.append('organization', project.organization.id);
        const response = await axiosApi.post('v2/projects/files/', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        await getImages(project.organization.id);
        return response.data;
      } catch (error) {
        message.error(error.message);
        throw error;
      }
    },
    [project, getImages],
  );

  const deleteImage = useCallback(
    async (imageId) => {
      try {
        if (!project) return;
        await axiosApi.delete(`v2/projects/files/${imageId}/`);
        await getImages(project.organization.id);
      } catch (error) {
        if (error.isAxiosError) message.warning({ content: error.message, duration: 3 });
        else throw new Error(error);
      }
    },
    [project, getImages],
  );

  const uploadFont = useCallback(
    async (file) => {
      if (!project) return;
      return await appBackendApi.uploadFont(file, project.organization.id);
    },
    [project],
  );

  const deleteFont = useCallback(
    (id) => {
      appBackendApi.deleteFont(id, project?.organization?.id);
    },
    [project],
  );

  return { uploadImage, deleteImage, uploadFont, deleteFont };
}
